import type { HackerStatus } from '@/types';
import { extractGithubUsername } from '../githubUsername';
import { CredentialFace } from './CredentialFace';
import { CredentialShell } from './CredentialShell';
import { CREDENTIAL_EDITIONS } from './editions';
import type { CredentialEditionSlug } from './types';

// One component for status-view-hack-26-{ar,mx,co}.tsx and the credential-view-26-*.tsx
// they wrapped: the edition only chooses which entry of CREDENTIAL_EDITIONS is used (G5).
export function CredentialView({
  edition,
  statusData,
}: {
  edition: CredentialEditionSlug;
  statusData: HackerStatus;
}) {
  const config = CREDENTIAL_EDITIONS[edition];

  const handle =
    extractGithubUsername(statusData.hacker.github) ||
    statusData.hacker.fullName;

  const selectedWord =
    statusData.hacker.gender === 'female' ? 'seleccionada' : 'seleccionado';

  return (
    <CredentialShell
      face={
        <CredentialFace
          data={{ name: statusData.hacker.fullName, handle }}
          config={config.face}
        />
      }
      backgroundItems={config.backgroundItems}
      city={config.city}
      dateRange={config.dateRange}
      handle={handle}
      selectedWord={selectedWord}
      share={config.share}
      exportArt={config.exportArt}
    />
  );
}
